import BoxContent from "../../../shared/ui/BoxContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PageTitle from "../../../shared/ui/PageTitle";
import React from "react";
import ContactForm from "../components/ContactForm";

const PNRR = () => {

    return (
        <Box component="main">
            <PageTitle>
                Planul Național de Redresare și Reziliență
            </PageTitle>
            <Typography variant="body1">Brio – prima și singura platformă de testare standardizată din România –
                vine în întâmpinarea nevoilor identificate în sistemul educațional românesc, oferind instrumentele
                de lucru necesare îndeplinirii obiectivelor din proiectul „România Educată”.
            </Typography>
            <Typography variant="body1">Testele standardizate digitale Brio pentru materiile școlare: matematică,
                limba română, istorie, fizică, chimie, biologie și geografie, acoperind întreaga programă școlară,
                făcând posibilă monitorizarea și evaluarea performanței elevilor. Testarea standardizată Brio oferă
                posibilitatea de identificare a nivelului real de cunoștințe, asigurând în același timp creșterea
                notelor și promovabilității în cazul examenelor naționale.
            </Typography>
            <Typography variant="body1">Pentru proiectul <a
                href="https://www.edu.ro/comunicat_presa_116_2022_lansare_apel_competitiv_proiecte_dotare_scoli_mobilier_materiale_didactice_echipamente_digitale"
                target="_blank" rel="noreferrer">„Dotarea cu mobilier, materiale didactice și echipamente
                digitale a unităților de învățământ preuniversitar și a unităților conexe”</a> lansat de Ministerul
                Educației prin PNRR (<a
                    href="https://www.edu.ro/sites/default/files/_fi%C8%99iere/Legislatie/2023/OME_3674_Corrigendum_Ghid_Dotari.pdf"
                    target="_blank" rel="noreferrer">Ordin nr. 3.674/14.02.2023</a>), Brio pune la dispoziția școlilor eligibile
                abonamente anuale nelimitate la prețul de 59 RON/copil din grupul țintă luat în calcul. Pentru
                calcularea și comunicarea necesarului către UAT va fi folosită următoarea formulă:
            </Typography>
            <Typography variant="body1" fontWeight="bold">59 (RON) x nr. de copii din școală x 3 ani (durata
                programului) = TOTAL NECESAR*
            </Typography>
            <Typography variant="body2">* în RON, fără TVA.</Typography>
            <Typography variant="h3" mt={3} mb={3}>Intră în legătură cu noi pentru mai multe informații</Typography>
            <Typography variant="body1"><b>Telefon: </b> <a href="tel:+40751237170">0751.237.170</a> (L-V, 10:00-17:00)</Typography>
            <BoxContent mt={3}>
                <Typography variant="body1">Completează formularul și te vom contacta în cel mai scurt
                    timp.</Typography>
                <ContactForm type="PNRR"/>
            </BoxContent>
        </Box>
    )
}

export default PNRR;